import req from './../../../fetch';
import { undocumentedResponse, paramsToString } from './../../../utils';
import {
  AllAPIResponses,
  CarbonError,
  UserType,
  CarbonQueryResult,
  CarbonQueryBodyType,
} from './../../../index';

type Params = {
  detail?: boolean;
};
type ResponseType = CarbonQueryResult<UserType>;
const post = async (
  params: Params,
  payload: CarbonQueryBodyType,
  headers?: Headers
): Promise<AllAPIResponses<ResponseType>> => {
  try {
    const resp = await req.post(
      `/api/users/query${paramsToString(params)}`,
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as ResponseType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
